import React, { useState, useEffect, useRef } from 'react';
import {
  Col,
  Row,
  Container,
  Form,
  Input,
  InputGroupAddon,
  InputGroup,
  InputGroupText,
} from 'reactstrap';
import image from '../images/farm.jpeg';
import queryString from 'query-string';
import { useHistory, useLocation } from 'react-router-dom';

const Base = (props: any) => {
  const history = useHistory();
  const location = useLocation();

  const [queryInput, setQueryInput] = useState('');
  const [searchQuery, setSearchQuery] = useState(location.search);

  const prevSearchQueryRef = useRef(searchQuery);
  const prevLocationSearchRef = useRef(location.search);

  useEffect(() => {
    if (location.pathname === '/recipes') {
      if (searchQuery !== prevSearchQueryRef.current) {
        prevSearchQueryRef.current = searchQuery;
        history.push(`/recipes${searchQuery}`);
      }
    }
  }, [searchQuery, location.pathname, history]);

  useEffect(() => {
    if (location.pathname === '/recipes') {
      if (location.search !== prevLocationSearchRef.current) {
        prevLocationSearchRef.current = location.search;
        const parsed = queryString.parse(location.search);
        let stringified = queryString.stringify(parsed);
        if (stringified !== '') {
          setSearchQuery('?' + stringified);
        } else {
          setSearchQuery('');
        }
      }
    }
  }, [location.search, location.pathname]);

  const handleRecipeSearch = (e) => {
    e.preventDefault();
    const parsed = queryString.parse(location.search);
    parsed.query = queryInput;
    if (parsed.page) {
      parsed.page = undefined;
    }
    let stringified = queryString.stringify(parsed);
    setQueryInput('');
    setSearchQuery('?' + stringified);
  };

  const handleChange = (e) => {
    setQueryInput(e.target.value);
  };

  return (
    <div>
      <img
        style={{ height: '30vh', minHeight: '350px', objectFit: 'cover' }}
        className="d-block w-100 overflow-hidden  position-absolute"
        src={props.image ? props.image : image}
        alt={props.title}
      />
      <div
        className=" text-center w-100 position-relative"
        style={{
          top: 0,
          height: '30vh',
          minHeight: '350px',
          backgroundColor: props.overlay && 'rgba(14, 13, 13, 0.303)',
        }}
      >
        <Container className=" w-100 h-100  ">
          <Row className=" my-auto h-100 ">
            <Col className=" my-auto ">
              <div className=" text-center text-light">
                <h1 className=" base-header font-weight-bold ">{props.title}</h1>
                {props.searchBar && (
                  <Form
                    style={{ paddingLeft: '20%', paddingRight: '20%' }}
                    onSubmit={handleRecipeSearch}
                  >
                    <InputGroup className="pt-5 " size="lg">
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText style={{ backgroundColor: 'white' }}>
                          {' '}
                          <i className="fas fa-search"></i>
                        </InputGroupText>
                      </InputGroupAddon>
                      <Input
                        placeholder="Recipe Search"
                        value={queryInput}
                        name="queryInput"
                        onChange={handleChange}
                      />
                    </InputGroup>
                  </Form>
                )}
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default Base;
